module.exports = {"TXTWCL_This_popular_bet_builder_has_b_ELL":{"id":"TXTWCL_This_popular_bet_builder_has_b_ELL","defaultMessage":"この人気のベット ビルダーは {0} 回利用されました"}}